// extracted by mini-css-extract-plugin
export default {"container":"distributor-stack-report_container__h3Upp"};